import lodash from "lodash";
import { BindAll } from "lodash-decorators";
import { computed } from "mobx";
import { EnumAPI } from "../../apis";
import { AjaxBasics } from "../../helpers";
import { BaseModel } from "../bases";

@BindAll()
export class SubscriptController {
  /**
   * @des 是否绑定了微信
   */
  async onSubscriptionOfUser(body) {
    return await AjaxBasics.request({
      ...EnumAPI.subscriptionOfUser,
      body,
    });
  }

  /**
   * @des 订阅成功
   */
  async onSubscriptionOfAuthorization(body) {
    return await AjaxBasics.request({
      ...EnumAPI.subscriptionOfAuthorization,
      body,
    });
  }

  /**
   * @des 返回授权登陆的地址
   */
  async onGetAuthorizationUrl(body) {
    return await AjaxBasics.request({
      ...EnumAPI.getAuthorizationUrl,
      body,
    });
  }
}
